import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";

const WordDraggable = ({handle, id, type, name, children}) => {
  
  const {attributes, isDragging, setNodeRef, listeners, transform} = useDraggable({
    id: id,
    data: {
      type: type,
      name: name,
    },
  });

  return (
    <span
      ref={setNodeRef}
      className="word-item border-[1.8px] border-solid border-black rounded-[30px] pl-1 tracking-[0.2rem] text-[20px] font-bold inline-block"
      style={{ transform: CSS.Translate.toString(transform) }}
      {...attributes}
      {...listeners}
    >
      {name}
    </span>
  );
};

export default WordDraggable;
